import type { PaletteOptions } from '@mui/material/styles';

import { colorScales } from '../common/colors';

/**
 * Light theme palette colors
 * Complete light mode color palette
 */
export const lightPalette: PaletteOptions = {
  mode: 'light',

  primary: {
    main: '#0063B3',
    light: '#64B5F633',
    dark: '#004A8C',
  },
  secondary: {
    main: '#0A0A0A',
  },
  error: {
    main: '#E84749',
  },
  warning: {
    main: '#FAAD14',
  },
  info: {
    main: '#00C3F0',
  },
  success: {
    main: '#009000',
  },

  background: {
    default: '#EFEFF2',
    paper: '#FFFFFF',
  },

  text: {
    primary: '#0A0A0A',
    secondary: '#707070',
    tertiary: '#8F8F8F',
    disabled: '#BDBDBD',
  },

  accent: {
    green: '#1B9E5C',
    blue: '#2178EF',
  },

  action: {
    active: 'rgba(0, 0, 0, 0.54)',
    hover: 'rgba(0, 0, 0, 0.04)',
    selected: 'rgba(0, 0, 0, 0.08)',
    disabled: 'rgba(0, 0, 0, 0.26)',
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
  },

  divider: 'rgba(0, 0, 0, 0.12)',

  ...colorScales,
};
